/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-07T11:35:36-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T12:10:19-07:00
*/


import React, { Component, PropTypes } from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing, color, textColor, type } from '../../style';
// import Button from './Button'

const style = StyleSheet.create({
  checkboxContainer: {
    display: 'table',
    ...spacing.MARGIN_TOP_SM,
    ...spacing.MARGIN_BOTTOM_SM,
    cursor: 'pointer'
  },

  checkboxHolder: {
    display: 'table-cell',
    paddingRight: '8px'
  },

  checkboxInput: {
    position: 'absolute',
    width: '0',
    opacity: '0'
  },

  checkbox: {
    background: '#fff',
    border: '1px solid #DBDBDB',
    borderRadius: '2px',
    height: '18px',
    width: '18px',
    display: 'inline-block',
    textAlign: 'center',
    overflow: 'hidden',
    verticalAlign: 'middle'
  },

  focus:  {
    borderColor: color.BRAND_1
  },

  checkmark: {
    position: 'relative',
    display: 'inline-block',
    left: '-1px',
    margin: '-8px',
    verticalAlign: 'top',
  },

  checked: {
    backgroundColor: color.BRAND_1,
    borderColor: color.BRAND_1
  },

  label: {
    ...spacing.PADDING_LEFT_SM,
    display: 'table-cell',
    verticalAlign: 'middle',
  },

  label_MD: {
    ...type.MD
  },

  inline: {
    display: 'inline-table',
    ...spacing.MARGIN_RIGHT_MD
  }
});

const classes = (inline) => {
  return [
    inline && style.inline
  ]
}

class Checkbox extends Component {
  constructor() {
    super();
    this.state = {focused: false};
    this.focusHandler = this.focusHandler.bind(this);
    this.blurHandler = this.blurHandler.bind(this);
  }

  focusHandler() {
    this.setState({focused: true})
  }

  blurHandler() {
    this.setState({focused: false})
  }

  render() {
    const {
      label,
      children,
      inline,
      size,
      error,
      ...rest } = this.props;

    return (
      <label className={css(style.checkboxContainer, classes(inline))}>
        <span className={css(style.checkboxHolder)}>
          <input
            onFocus={this.focusHandler}
            onBlur={this.blurHandler}
            className={css(style.checkboxInput)}
            type="checkbox"
            {...rest}
          />
          <span className={css(
              style.checkbox,
              this.state.focused && style.focus,
              this.props.value && style.checked,
            )}>
            {this.props.value &&
              <span className={css(style.checkmark)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" fill="currentColor" fillOpacity="0" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{height: '32px', width: '32px', display: 'block'}}><path d="M19.1 25.2l4.7 6.2 12.1-11.2"></path></svg>
              </span>
            }
          </span>
        </span>
        <span>{label || children}</span>
      </label>

    )
  }
}

Checkbox.propTypes = {
  onChange: PropTypes.any.isRequired,
  label: PropTypes.any,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/Checkbox.jsx